<div class="regional-sales-wrapper">
	<div class="regional-sales-title">REGIONAL SALES (YTD)</div>
	<!-- National Row -->
	<div class="regional-sales-region">
		<div class="regional-sales-region-name"><b>National</b></div>
		<div class="regional-sales-table">
			<div class="regional-sales-row regional-sales-header">
				<div class="regional-sales-cell"><b>THIS YEAR</b></div>
				<div class="regional-sales-cell"><b>LAST YEAR</b></div>
				<div class="regional-sales-cell"><b>VAR%</b></div>
			</div>
			<div class="regional-sales-row">
				<div class="regional-sales-cell text-end"><b>{{ this.nationalWeekly | currency:'USD':'symbol':'1.0-0' }}</b></div>
				<div class="regional-sales-cell text-end"><b>{{ this.nationalLastYearYtdSales | currency:'USD':'symbol':'1.0-0' }}</b></div>
				<div class="regional-sales-cell text-end"
					[ngStyle]="this.nationalVarience >= 0 ? {'color':'green'} : {'color':'red'}">
					<ng-container *ngIf="this.nationalLastYearYtdSales == 0 && this.nationalWeekly > 0; else normalNationalVar">
						<b>&#8734;%</b>
					</ng-container>
					<ng-template #normalNationalVar>
						<b>{{ (this.nationalVarience > 0 ? this.nationalVarience : this.nationalVarience * -1) | number:'1.1-1' }}%</b>&nbsp;
					</ng-template>
					<img style="width:7%;" 
						 [src]="this.nationalVarience >= 0 ? 'assets/images/arrows/up.png' : 'assets/images/arrows/down.png'" 
						 alt="arrow" />
				</div>
			</div>
		</div>
	</div>
	<div *ngFor="let region of regionalSalesData" class="regional-sales-region">
		<div class="regional-sales-region-name">{{ region.name }}</div>
		<div class="regional-sales-table">
			<div class="regional-sales-row regional-sales-header">
				<div class="regional-sales-cell">THIS YEAR</div>
				<div class="regional-sales-cell">LAST YEAR</div>
				<div class="regional-sales-cell">VAR%</div>
			</div>
			<div class="regional-sales-row">
				<div class="regional-sales-cell text-end">{{ region.thisYear | currency:'USD':'symbol':'1.0-0' }}</div>
				<div class="regional-sales-cell text-end">{{ region.lastYear | currency:'USD':'symbol':'1.0-0' }}</div>
				<div class="regional-sales-cell regional-sales-var text-end"
					 [ngStyle]="region.varPercent >= 0 ? {'color':'green'} : {'color':'red'}">
					<ng-container *ngIf="region.lastYear == 0 && region.thisYear > 0; else normalVar">
						&#8734;%
					</ng-container>
					<ng-template #normalVar>
						{{ (region.varPercent > 0 ? region.varPercent : region.varPercent * -1) | number:'1.1-1' }}%
					</ng-template>
					<img style="width:7%;" 
						 [src]="region.varPercent >= 0 ? 'assets/images/arrows/up.png' : 'assets/images/arrows/down.png'" 
						 alt="arrow" />
				</div>
			</div>
		</div>
	</div>
</div>
<!-- <mat-card class="regional-sales">
			<div class="section-title">Regional Sales (YTD)</div>
			<table class="regional-table">
				<thead>
					<tr>
						<th></th>
						<th>This Year</th>
						<th>Last Year</th>
						<th>VAR%</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>National</td>
						<td>$221,847</td>
						<td>$1,459,191</td>
						<td class="down">-84.8%</td>
					</tr>
					<tr>
						<td>Auckland East</td>
						<td>$5,507</td>
						<td>$135</td>
						<td class="up">3,385.2%</td>
					</tr>
					<tr>
						<td>Auckland</td>
						<td>$26,340</td>
						<td>$1,475,033</td>
						<td class="down">-85.2%</td>
					</tr>
				</tbody>
			</table>
		</mat-card> -->